<template>
    <AppLayout
        page="/dashboard"
        pageTitle="Teacher Pay"
        backLink="/dashboard/reports"
    >
        <v-col cols="12" class="pa-1">
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="soli-subtitle"
                                    >{{
                                        `${globalMomentMonthFull(
                                            rangeStart
                                        )} ${globalMomentYear(rangeStart)}`
                                    }}
                                </v-list-item-title>
                                <v-list-item-subtitle
                                    style="white-space: normal"
                                    >Monthly pay due to
                                    teachers</v-list-item-subtitle
                                >
                                <v-list-item-subtitle
                                    class="font-bold"
                                    style="white-space: normal"
                                    >{{ total }} earned in
                                    {{ teachers.length }} teacher(s)
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-row>
                                    <v-btn
                                        :small="$vuetify.breakpoint.xs"
                                        icon
                                        class="elevation-3"
                                        @click="range(-1)"
                                        ><v-icon color="dark"
                                            >chevron_left</v-icon
                                        ></v-btn
                                    >
                                    <v-btn
                                        :small="$vuetify.breakpoint.xs"
                                        icon
                                        class="elevation-3 ml-1"
                                        @click="range(1)"
                                        ><v-icon color="dark"
                                            >chevron_right</v-icon
                                        ></v-btn
                                    >
                                    <v-menu
                                        right
                                        :close-on-content-click="false"
                                        v-if="$vuetify.breakpoint.xs"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                :small="$vuetify.breakpoint.xs"
                                                icon
                                                class="elevation-3 ml-1"
                                            >
                                                <v-badge
                                                    color="accent"
                                                    overlap
                                                    bordered
                                                    dot
                                                    :value="search"
                                                >
                                                    <v-icon
                                                        class="soli-blue-text text-shadow-blue"
                                                        >filter_list</v-icon
                                                    >
                                                </v-badge></v-btn
                                            >
                                        </template>
                                        <v-list
                                            ><v-list-item class="pl-0">
                                                <v-text-field
                                                    v-model="search"
                                                    class="pl-6 white pt-0 mt-0"
                                                    label="Filter"
                                                    single-line
                                                    clearable
                                                    :append-icon="
                                                        search
                                                            ? null
                                                            : 'filter_list'
                                                    "
                                                    hide-details
                                                ></v-text-field></v-list-item></v-list
                                    ></v-menu>
                                </v-row>
                            </v-list-item-action>
                            <v-list-item-action
                                v-if="$vuetify.breakpoint.smAndUp"
                            >
                                <v-text-field
                                    v-model="search"
                                    style="width: 200px"
                                    class="pl-6"
                                    append-icon="filter_list"
                                    label="Filter"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </v-list-item-action> </v-list-item
                    ></v-list>
                    <v-data-table
                        :headers="headers"
                        :items="teachers"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        :search="search"
                    >
                        <template v-slot:[`item.name`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <v-list-item-avatar
                                    style="float: left"
                                    class="my-0"
                                >
                                    <v-img
                                        :src="item.profile_photo_url"
                                    ></v-img>
                                </v-list-item-avatar>
                                <div>
                                    <v-list-item-title>
                                        <Link
                                            :href="`/profile/${item.id}/manage`"
                                        >
                                            {{ item.name }}
                                        </Link>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.email }}
                                    </v-list-item-subtitle>
                                </div>
                            </div>
                        </template>

                        <template v-slot:[`item.totalPay`]="{ item }">
                            <div class="font-bold soli-grey">
                                {{ formatUnitAmount(item.totalPay) }}
                            </div>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-col>
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import globalMoment from "../../Mixins/GlobalMoment";

export default {
    props: ["teachers", "rangeStart"],
    mixins: [globalMoment],
    components: {
        AppLayout,
        Link,
    },
    data() {
        return {
            search: "",
            headers: [
                {
                    text: "Teacher",
                    align: "start",
                    sortable: true,
                    value: "name",
                },
                {
                    text: "Total Pay",
                    align: "start",
                    sortable: true,
                    value: "totalPay",
                },
                {
                    text: "Total Hours",
                    align: "start",
                    sortable: true,
                    value: "totalHours",
                },
                {
                    text: "Attended",
                    align: "start",
                    sortable: true,
                    value: "Attended.hoursScheduled",
                },
                {
                    text: "Early Cancelled",
                    align: "start",
                    sortable: true,
                    value: "Early-cancel.hoursScheduled",
                },
                {
                    text: "Late Cancelled",
                    align: "start",
                    sortable: true,
                    value: "Late-cancel.hoursScheduled",
                },
                {
                    text: "No-show",
                    align: "start",
                    sortable: true,
                    value: "No-show.hoursScheduled",
                },
                {
                    text: "Teacher Cancelled",
                    align: "start",
                    sortable: true,
                    value: "Teacher-cancel.hoursScheduled",
                },
                {
                    text: "Cancel Credits",
                    align: "start",
                    sortable: true,
                    value: "Cancel-credit.hoursScheduled",
                },
                {
                    text: "Courtesy Cancelled",
                    align: "start",
                    sortable: true,
                    value: "Courtesy Cancelled.hoursScheduled",
                },
                {
                    text: "Missed Attendance",
                    align: "start",
                    sortable: true,
                    value: "Missed Attendance.hoursScheduled",
                },
            ],
        };
    },
    methods: {
        range(adjust) {
            this.$inertia.visit(
                `/dashboard/reports/teacher-pay/${moment(
                    new Date(this.rangeStart)
                )
                    .tz("UTC")
                    .add(adjust, "M")
                    .startOf("month")
                    .format("YYYY-MM-DD")}`
            );
        },
    },
    computed: {
        total() {
            return this.formatUnitAmount(
                this.teachers
                    .map((e) => e["totalPay"])
                    .reduce((a, b) => a + b, 0)
            );
        },
    },
};
</script>
